import CountdownTimer from "../CountdownTimer";

export default function ActionStatusLabel({ item }) {
  const getCurrentUTCDate = () => {
    const now = new Date();
    return new Date(Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    ));
  };

  const currentDate = getCurrentUTCDate();
  const startDate = item?.start_date_time && new Date(`${item?.start_date_time}Z`);
  const endDate = item?.end_date_time && new Date(`${item?.end_date_time}Z`);
  const duration = item?.duration;

  const hasEnded = endDate < currentDate || item?.status != 1;
  const notStart = startDate > currentDate;

  function resetTimeToMidnight(date) {
    const newDate = new Date(date);
    newDate.setUTCHours(0, 0, 0, 0);
    return newDate;
  }

  const isTodayStart =
    resetTimeToMidnight(currentDate).getTime() ===
    resetTimeToMidnight(startDate).getTime();

  const getDateFormat = (dateString) => {
    const date = new Date(dateString + 'Z');
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC'
    });
  };

  // Calculate difference in hours
  const diffStartInHours = (startDate - currentDate) / (1000 * 60 * 60);
  const diffEndInHours = (endDate - currentDate) / (1000 * 60 * 60);

  const showStartCountdown = diffStartInHours <= 24 && diffStartInHours > 0;
  const showEndCountdown = diffEndInHours <= 24 && diffEndInHours > 0;

  return (
    <div>
      {hasEnded ? (
        <p className="end-in">Already Ended</p>
      ) : !notStart ? (
        <p className="end-in">
          Ends {showEndCountdown ? "in" : "on"}:{" "}
          {showEndCountdown ? (
            <CountdownTimer startDate={endDate.toISOString()} duration={duration} />
          ) : (
            getDateFormat(item?.end_date_time)
          )}
        </p>
      ) : (
        <p className="end-in">
          Start {showStartCountdown ? "in" : "on"}:{" "}
          {showStartCountdown ? (
            <CountdownTimer startDate={startDate.toISOString()} duration={duration} />
          ) : (
            getDateFormat(item?.start_date_time)
          )}
        </p>
      )}
    </div>
  );
}
